function TableDetails({ order }) {
    if (!order) {
      return null;
    }
  
    return (
        <div className="product-table-container">
            <h2 className='info-heading'>Pasūtījuma #{order.id} produkti:</h2>
            <table className='product-table'>
            <thead>
                <tr>
                <th>ID</th>
                <th>Nosaukums</th>
                <th>Summa (bez PVN)</th>
                <th>PVN</th>
                <th>Summa</th>
                <th>Kods</th>
                </tr>
            </thead>
            <tbody>
                {order.line_items.map((item) => (
                <tr key={item.id}>
                    <td>{item.product_id}</td>
                    <td>{item.name}</td>
                    <td>€{item.subtotal - item.subtotal_tax}</td>
                    <td>€{item.subtotal_tax}</td>
                    <td>€{item.subtotal}</td>
                    <td>{item.sku}</td>
                </tr>
                ))}
            </tbody>
            </table>
        </div>
)}

export default TableDetails;